import { Amount } from '@fcom/dapi/interfaces';

/**
 * Adds up two amounts. Assumes they have a matching currencyCode.
 */
export const sumAmounts = (acc: Amount | null, cur: Amount): Amount => ({
  currencyCode: acc?.currencyCode || cur?.currencyCode,
  amount: String(Number(acc?.amount || '0') + Number(cur?.amount || '0')),
});
